// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// @greenlight-spec: 09-data-brokering.md
/**
 * Salesforce External Client App → Greenlight client-credentials registration
 * guide. Seeded into the catalog as `acquisitionInstructions` (string for the
 * agent/docs surface) and rendered inside one register-form accordion.
 */
export const SALESFORCE_CLIENT_CREDENTIALS_STEPS = [
    {
        title: 'Check your edition includes API access',
        body: 'Enterprise, Performance, Unlimited, and Developer Edition include API access. Professional Edition needs the Web Services API add-on.',
        details: 'Without API access, every API call fails with API_DISABLED_FOR_ORG. Group and Essentials Edition cannot add API access. In Professional Edition, the Additional API Calls product raises limits but does not turn API access on; ask your Salesforce account executive for the Web Services API product.',
    },
    {
        title: 'Create an External Client App',
        body: 'Setup → External Client App Manager → New. Prefer this over a legacy Connected App.',
    },
    {
        title: 'OAuth settings',
        body: 'Enable OAuth. Add any callback URL (required by the form; Client Credentials does not use it).\n' +
            'Scope: add "Manage user data via APIs (api)" at minimum.',
    },
    {
        title: 'Enable Client Credentials (settings)',
        body: 'Under Flow Enablement, check Enable Client Credentials Flow only, then choose OK in the "Confirm Enablement of the Client Credential Flow" dialog. ' +
            'Leave Authorization Code, Device Flow, JWT Bearer, and Token Exchange off unless you need them elsewhere.',
    },
    {
        title: 'Enable Client Credentials + Run As (Policies)',
        body: 'Open the Policies tab → Edit → OAuth Policies → OAuth Flows and External Client App Enhancements. Enable Client Credentials Flow again, then set Run As (username).\n' +
            'Run As must be Active, with API Enabled (an API Only User is ideal). Least-privilege profile/permission sets.\n' +
            'Ignore OAuth Start URL under Plugin Policies — that is for Authorization Code only.',
    },
    {
        title: 'Copy Consumer Key and Secret',
        body: 'Settings tab → OAuth Settings → App Settings → Consumer Key and Secret. Salesforce may email a verification code before showing them.\n' +
            'Enter your My Domain in the My Domain field on this form. Put the Consumer Key in Consumer Key (client ID) on this form; paste only the Consumer Secret under Credentials.',
    },
];
/** Flat multi-line copy for catalog `acquisitionInstructions`. */
export function formatAcquisitionGuideSteps(steps) {
    return steps
        .map((step, i) => `${i + 1}. ${step.title}\n${step.body}${step.details ? `\n${step.details}` : ''}`)
        .join('\n\n');
}
//# sourceMappingURL=salesforce-client-credentials-guide.js.map